<template>
  <div>
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <div class="float-right" id="top" style="position:relative">
        <b-pagination-nav v-model="currentPage" :link-gen="linkGen()" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>

        <div style="position:absolute;left:-300px;top:0px;display:none">
          <b-form @submit.prevent="reloadAll()"><b-form-input debounce="1000" size="sm" placeholder="Search Title/Url" v-model="searchQuery"></b-form-input>

          </b-form>
        </div>
    </div>

    <h1 class="page-title">Explore</h1>

      <change-viewer :options="changeViewer"></change-viewer>
    <b-alert v-if="!scanStatus.completed" show variant="primary"><b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner> Check in progress.<br>
      Results will show up here automatically</b-alert>

    <b-row v-for="page in pages">
      <b-col lg="7">
        <div style="position:relative;white-space:nowrap;z-index:99" :class="{'overflow-wrap': isMobile}">
          <span class="circle bg-success text-success mr-xs" style="font-size: 8px;line-height:15px">.</span>
          <a :href="page.url" target="_blank"  v-b-tooltip.hover title="External Link"><b>{{page.url | truncate(100)}}</b></a>
        </div>
        <div :class="{'table-responsive': !isLargeScreen, 'hide-scrollbars-large': true}">
          <table class="" >
            <tr>
              <td>
                <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }"  title="Page Details" class="image-link">
                  <div class="mr-lg d-flex align-items-center" style="position:relative">

                    <vue-load-image>
                      <img slot="image" width=380  :src="`${page.screenshots['chrome'].main.screenshot.url}?tr=w-380`" class="desktop-preview">
                      <div slot="preloader" class="image-loading-container" style="width:380px;height:200px;box-shadow: 0 0 40px #f0f3ff;"><div><b-spinner label="Loading..." ></b-spinner><br>Loading.. </div></div>
                      <div slot="error" class="screenshot-error">
                        <p></p>
                        <h4>Cannot Load Image.</h4>
                        <p>
                          If this problem persists please let us know.
                        </p>
                        <i class="fa fa-warning"></i>
                      </div>
                    </vue-load-image>
                    <img src="/iphone.png" width="122" style="">

                    <vue-load-image v-if="page.screenshots['galaxy_s6']">
                      <img slot="image"  :src="`${page.screenshots['galaxy_s6']['main'].screenshot.url}?tr=w-108`" width="108" style="position:absolute;left:387px;top:20px;border-radius:4px">
                      <div slot="preloader" class="image-loading-container" style="width:108px;height:192px;position:absolute;left:387px;top:20px;border-radius:4px"><div><b-spinner label="Loading..." ></b-spinner></div></div>
                      <div slot="error"  class="screenshot-error" style="width:108px;height:188px;position:absolute;left:387px;top:19px;">
                        <div>Cannot load screenshot<p> <i class="fa fa-warning"></i></p></div></div>
                    </vue-load-image>
                  </div>
                </router-link>
              </td>
            </tr>

          </table>
        </div>
      </b-col>
      <b-col lg="5">&nbsp;
        <div class="pb-sm h-90">
          <Widget  class="h-90 mb-0" :updating="pageUpdating(page)" :title="page.title | truncate(100)" style="padding-bottom:0;min-height:225px" :fetchingData="page.trends.history.categories.length === 0">
            <p class="text-muted">
<!--            <small class="mr-lg d-flex align-items-center">Last checked {{page.crawl_date | moment('from')}}</small>-->

              <small>
                <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }"  v-b-tooltip.hover title="Page Details"><i class="fa fa-eye"></i> Page Details</router-link>
              </small>
            </p>
            <div :key="page.trends.key">
                <b-container v-if="page.trends.performance.length > 0" class="mt-0" :key="page.trends.performance.length">
                  <b-row class="text-center text-muted">
                    <b-col  class="p-0">

                      <spark-line :pad="pad" :rails="[49, 89, 100]" :data="page.trends.performance"></spark-line>
                      <small>Performance</small>

                    </b-col>
                    <b-col  class="p-0">
                      <spark-line :pad="pad" units="ms" :rails="[3800, 7300]" :inverse="true" :data="page.trends.interactive"></spark-line>
                      <small>TTI</small>
                    </b-col>
                    <b-col  class="p-0">
                      <spark-line :pad="pad" units="ms" :rails="[2000, 4000]" :inverse="true" :data="page.trends.first_contentful_paint"></spark-line>
                      <small>FCP</small>
                    </b-col>
                  </b-row>
                </b-container>
                <div v-if="page.trends.history.categories.length > 0">
                  <heat-graph @clickEvent="clickEvent" :emitEvent="true" :pad="0" :hideXLabels="true" :height="60" :options="page.trends.history"></heat-graph>
                </div>
            </div>


          </Widget>
        </div>
      </b-col>


    </b-row>

    <div class="float-right">
      <b-pagination-nav v-model="currentPage" :link-gen="linkGen('#top')" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
    </div>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import DemoNotice from "@/components/DemoNotice/DemoNotice";
import HeatGraph from "@/components/TrendGraph/HeatGraph";
import SparkLine from "@/components/TrendGraph/SparkLine";
import ChangeViewer from "@/components/ChangeViewer/ChangeViewer";

import axios from "axios";
import gql from "graphql-tag";
import { mapState } from 'vuex';
import VueLoadImage from 'vue-load-image'
export default {
  name: 'Dashboard',
  components: { Widget, ChangeViewer, 'vue-load-image': VueLoadImage, DemoNotice, HeatGraph, SparkLine },
  apollo: {
    $subscribe: {
      changes:{
      query(){
        return gql`subscription getChanges($siteId: Int, $paths: [String!]){

          changes:websites_crawledpage(where: {website_id: {_eq: $siteId}, path: {_in: $paths}}, order_by: {crawl_date: desc}, limit: ${this.pagePaths.length * 15}){
            id
            path
            crawl_id
            crawl_date
            websites_diffs(where: {ready: {_eq: true}, type: {_eq: 17}, websites_devicerender:{device_id:{_eq:"chrome"}}}){
                id
                ratio
                type
            }
          }
        }`

      },
      result(data){
        for (let page of this.pages){
          page.trends.history =  {
            series:[
              {name: 'Changes', data:[]}
            ],
            categories: [],
            categoryParams: [],
          }
        }
        for (let i=data.data.changes.length-1; i>=0; i--){
          let entry = data.data.changes[i];
          let pageIndex = this.pages.findIndex( (p)=> {return p.path === entry.path});
          if (pageIndex === -1){
            continue
          }
          let page = this.pages[pageIndex];
          page.trends.history.series[0].data.push((entry.websites_diffs[0] || {}).ratio || 0);
          page.trends.history.categoryParams.push({id: entry.id, path: page.path});
          page.trends.history.categories.push(new Date(entry.crawl_date).getTime());

          page.trends.key = page.trends.history.categories.length + page.trends.performance.length;
          this.$set(this.pages, pageIndex,page);
        }
        this.dataLoaded.changes += 1;

      },
      variables(){
        return {
          siteId: this.activeSite.id,
          paths: this.pagePaths
        }
      },
      skip(){
        return !(this.pagePaths.length > 0) || (this.dataLoaded.changes && this.scanStatus.completed)
      }
    },
    trends:{
      query(){
        return gql`subscription getTrends($siteId: Int, $paths: [String!]){
           trends:websites_crawledpage(where: {website_id: {_eq: $siteId}, path: {_in: $paths}}, order_by:{crawl_date: desc}, limit: ${this.pagePaths.length * 5}){
            id
            path
            crawl_date
            websites_devicerenders(where: {device_id: {_eq: "galaxy_s6"}}){
              id
              websites_lighthousereport{
                id
                device_render_id
                ready
                status
                seo
                performance
                first_contentful_paint
                largest_contentful_paint
                first_cpu_idle
                first_meaningful_paint
                interactive
                cumulative_layout_shift
                speed_index
                total_blocking_time
                best_practices
                accessibility
                interactive
                network_slowest_request
                network_largest_request
                page_weight
              }
            }
           }
        }`

      },
      result(data){
        for (let page of this.pages){
          page.trends.performance = [];
          page.trends.interactive = [];
          page.trends.first_contentful_paint = [];
        }

        // for (let i=0; i<data.data.trends.length-1; i++){
        for (let i=data.data.trends.length-1; i>=0; i--){
          let entry = data.data.trends[i];
          let timestamp = entry.crawl_date;
          let lighthouse_report = entry.websites_devicerenders[0].websites_lighthousereport;
          if (!lighthouse_report){
            continue;
          }
          let performance = lighthouse_report.performance;
          let interactive = lighthouse_report.interactive;
          let first_contentful_paint = lighthouse_report.first_contentful_paint;
          let pageIndex = this.pages.findIndex( (p)=> {return p.path === entry.path});
          if (pageIndex === -1){
            continue
          }
          let page = this.pages[pageIndex];
          page.trends.performance.push({
            timestamp: timestamp,
            data: performance
          });
          page.trends.interactive.push({
            timestamp: timestamp,
            data: interactive
          });
          page.trends.first_contentful_paint.push({
            timestamp: timestamp,
            data: first_contentful_paint
          });
          page.trends.key = page.trends.history.categories.length + page.trends.performance.length;
          this.$set(this.pages, pageIndex , page)
        }
        this.dataLoaded.trends += 1;

      },
      variables(){
        return {
          siteId: this.activeSite.id,
          paths: this.pagePaths
        }
      },
      skip(){
        return !(this.pagePaths.length > 0) || (this.dataLoaded.trends && this.scanStatus.completed);
      }
    },
    websites_website: {
      query() {
        return gql`subscription getPages($siteId: Int){
          websites_website(where: {id: {_eq: $siteId}}) {
            id
            url
            websites_crawledpages(where: { ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300, _gte: 200}}, limit: ${this.pageSize}, offset: ${(this.currentPage-1) * this.pageSize || 0}, order_by: {level: asc, path: asc}) {
              title
              id
              crawl_date
              level
              url
              path

              websites_devicerenders{
                id
                device_id
                screenshots
                layout_errors_count
                websites_lighthousereport{
                  id
                  ready
                  status
                }
              }
              websites_link_pages_aggregate(where: {websites_link: {is_broken: {_eq: true}}}){
                aggregate{
                  count
                }
              }
              broken_images:websites_brokenresource_pages_aggregate(where: {websites_brokenresource: {resource_type: {_in: ["image"]}}}){
                aggregate{
                  count
                }
              }
              broken_resources:websites_brokenresource_pages_aggregate(where: {websites_brokenresource:{resource_type: {_in: ["js", "other"]}}}){
                aggregate{
                  count
                }
              }
              websites_spellingerror_pages_aggregate(where:{websites_spellingerror:{active: {_eq: true}}}){
                aggregate{
                  count
                }
              }
            }
            websites_crawledpages_aggregate(where: {ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300}}){
              aggregate {
                count
              }
            }
          }
        }`
      },
      variables(){
        return {
          siteId: this.activeSite.id,
          // search: '%'+this.searchQuery+'%'
        }
      },
      skip () {
        return !this.activeSite.id || (this.dataLoaded.websites_website && this.scanStatus.completed)
      },
      result (data) {
        this.pageCount = 0;
        this.numberOfPages = 1;
        if ((data.data.websites_website && data.data.websites_website.length)) {
          this.pagePaths = [];
          this.homePage = data.data.websites_website[0];
          this.homePage.pageCount = data.data.websites_website[0].websites_crawledpages_aggregate.aggregate.count;
          if (this.homePage.pageCount) {
            this.pageCount = this.homePage.pageCount;
            this.numberOfPages = Math.ceil(this.pageCount/this.pageSize);
            if (this.currentPage > this.numberOfPages) {
              this.$router.push({name: "ExplorePage"});
            }

            let cachedPages = this.pages;
            this.pages = data.data.websites_website[0].websites_crawledpages;
            for (let page of this.pages){
              this.pagePaths.push(page.path);
              let cachedPage = cachedPages.find( (p) => {return p.path === page.path});
              if (cachedPage){
                page.trends = cachedPage.trends;
              }
              else{
                page.trends = {
                  history: {
                    series:[
                      {name: 'History', data:[]}
                    ],
                    categories: [],
                  },
                  performance: [],
                  interactive: [],
                  first_contentful_paint: [],
                  key: 0,
                };
              }
              page.screenshots = {};
              page.layout_errors_count = 0;

              for (let s of page.websites_devicerenders){
                page.layout_errors_count += s.layout_errors_count;
                page.screenshots[s.device_id] = s.screenshots;
                if (!page.lighthouse_report && s.websites_lighthousereport && s.websites_lighthousereport.ready) {
                  page.lighthouse_report = s.websites_lighthousereport;
                }
              }
            }
          }
        }
        this.loading = false;
        this.dataLoaded.websites_website += 1;
      },

    },

    }
  },
  data() {
    return {
      pagePaths: [],
      searchQuery: '',
      changeViewer: {
        show: false,
        page: 0,
        path: ''
      },
      pad: 0,
      sections: [{ value: 92 , color:'#0CCE6B'},],
      lighthouseEndpoint: axios.defaults.baseURL+'lighthouse',
      pages: [],
      loading: true,
      dataLoaded: {
        websites_website: 0,
        trends: 0,
        changes: 0,
      },
      crawlVersion: 0,
      currentPage: 1,
      numberOfPages: 1,
      pageCount: 1,
      pageSize: 5,
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Explore Pages - PageWatch.dev',
    // all titles will be injected into this template
  },
  methods: {
    clickEvent(data){
      this.showComparison(data.id, data.path)
    },
    reloadAll(){
      this.dataLoaded = {
        websites_website: 0,
        trends: 0,
        changes: 0,
      }
      this.pagePaths = [];
    },
    showComparison(page_id, path){
      this.changeViewer.path = path;
      this.changeViewer.page = page_id;
      this.changeViewer.device = 'chrome';
      this.changeViewer.show = true;
    },
    pageUpdating(page){
      if (this.scanStatus.completed){
        return false
      }
      if (!this.scanStatus.site.crawlCompleted){
        return true;
      }
      return !!this.scanStatus.pages.find( (p)=>p.path === page.path)
    },
    lighthouseColor(value, line=false){
      if (value < 50) {
        if (line) {
          return '#FF4E42';
        } else {
          return '#FFEEEC';
        }
      }
      if (value < 90) {
        if (line) {
          return '#FFA400';
        } else {
          return '#FFF6E6';
        }
      }
      if (line) {
        return '#67E0A2';
      } else {
        return '#E7FAF0';
      }
    },
    linkGen(hash) {
      if (!hash){
        hash = '';
      }
      return (pageNum) =>{
        return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
      };
    },
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: 'user'}),
    isMobile(){
      return window.innerWidth < 768
    },
    isLargeScreen(){
      return window.innerWidth >= 1366
    }
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = {
        websites_website: 0,
        trends: 0,
        changes: 0,
      };
      this.pagePaths = [];
      this.currentPage = this.$route.query.page || 1;
    }
  },
  mounted(){
    this.$root.$on('scan_completed',  () => {

    });
  },
  created() {
    this.$watch("$route",() => {
      this.pagePaths = [];
      this.currentPage = this.$route.query.page || 1;
      this.dataLoaded = {
        websites_website: 0,
        trends: 0,
        changes: 0,
      }
    }, {
      immediate: true
    });
  }
};
</script>

<style src="./Explore.scss" lang="scss" scoped />
<style lang="scss">
  .lighthouse-text{
    font-size:8pt;
  }

  .overflow-wrap{
    overflow-x: auto;
  }
</style>
